import type { Availability } from '@ab-core/graphql/dist';
import type { FC } from 'react';
import React from 'react';
import type { AvailabilitiesProps } from '..';
import { InfoText } from '../deliveryTimeInfo';

type ZajadaczInfoType = Pick<Availability, 'zajadaczChannelAvailability' | 'mainChannelAvailability'> &
    Pick<AvailabilitiesProps, 'quantity'> & { identifier?: string };

enum ZAJADACZ_IDENTIFIER {
    CHANNEL874 = 'CHANNEL874',
    CHANNEL874LATE = 'CHANNEL874LATE'
}

export const ZajadaczInfo: FC<ZajadaczInfoType> = (props) => {
    const { quantity, zajadaczChannelAvailability, mainChannelAvailability, identifier } = props;
    const isValidIdentifier = Object.values(ZAJADACZ_IDENTIFIER).includes(identifier as ZAJADACZ_IDENTIFIER);
    const zajadaczChannelQuantity = zajadaczChannelAvailability?.availability?.availableQuantity;
    const mainChannelQuantity = mainChannelAvailability?.availability?.availableQuantity;

    if (!isValidIdentifier) {
        return <></>;
    }

    const showZajadaczText = () => {
        if (!zajadaczChannelQuantity) {
            return false;
        }

        if (quantity > zajadaczChannelQuantity) {
            return false;
        }

        if (mainChannelQuantity && quantity <= mainChannelQuantity) {
            return false;
        }

        return true;
    };

    if (!showZajadaczText()) {
        return <div className="flex-justify-content-space-between"></div>;
    }

    return (
        <div className="flex-justify-content-space-between">
            <InfoText color="warning" useTextKey={`productInfos.${identifier?.toLowerCase()}`} />
        </div>
    );
};
